<template>
  <CourseCatalogPage ranking />
</template>

<script>
import CourseCatalogPage from "./CourseCatalogPage.vue";

export default {
  name: "EasiestHardestCoursesPage",
  components: { CourseCatalogPage },
};
</script>
